module.exports = __webpack_public_path__ + "img/mydays-ticket-lp.3aff7c43.jpg";